@if (dataSource) {
  <icz-storage-units-table
    class="grow"
    tableTitle="Vyhledejte ukládací jednotku"
    tableId="storage-unit-insert-selection"
    [dataSource]="dataSource"
    [viewType]="StorageUnitView.STORAGE_UNIT_SELECT"
    (activeRowChanged)="itemSelected($event)"
  >
    <icz-label noDataLabel label="Žádné objekty"></icz-label>
  </icz-storage-units-table>
}
